import { useParams } from 'next/navigation';

import useGroupReservationsEnabled from 'hooks/useGroupReservationsEnabled';

import useGetListingById from './useGetListingById';
import useSearchValues from './useSearchValues';

const MULTI_UNIT_PROPERTY_TYPE = 'MTL';

const useIsGroupReservation = () => {
  const { isFtLoading, enabled: isGroupReservationEnabled } = useGroupReservationsEnabled();
  const { id } = useParams();
  const { rooms } = useSearchValues();
  const { property, isGettingListing } = useGetListingById({ id });

  let isGroupReservation = false;

  if (isGroupReservationEnabled && property?.type === MULTI_UNIT_PROPERTY_TYPE && rooms > 1) {
    isGroupReservation = true;
  }

  const isLoading = isFtLoading || isGettingListing;
  return {
    isGroupReservationEnabled,
    isLoading,
    isGroupReservation,
  };
};

export default useIsGroupReservation;
